import { render, staticRenderFns } from "./newInvitation.vue?vue&type=template&id=084ba0f4&scoped=true"
import script from "./newInvitation.vue?vue&type=script&lang=js"
export * from "./newInvitation.vue?vue&type=script&lang=js"
import style0 from "./newInvitation.vue?vue&type=style&index=0&id=084ba0f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084ba0f4",
  null
  
)

export default component.exports